$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *

    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.slick({
            fade: true,
            dots: true,
            arrows: false,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 4000,
            prevArrow: $(".js-hero-slider-nav-prev"),
            nextArrow: $(".js-hero-slider-nav-next"),
            responsive: []
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll to top
    // *
    // *

    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.js-scrolltop').fadeIn();
        } else {
            $('.js-scrolltop').fadeOut();
        }
    });

    $('.js-scrolltop').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page

    $(".js-hero-scrolldown").click(function () {
        $('html, body').animate({
            scrollTop: $(this).offset().top
        }, 1000);
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Link in a new window
    // *
    // *

    $('a[rel*="external"]').click(function () {
        $(this).attr('target', '_blank');
    });
    $('a[data-type*="link"]').click(function () {
        $(this).attr('target', '_blank');
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Vita
    // *
    // *
    $(".vita__btn").click(function () {
        $(this).closest(".vita__intro").slideUp();
        $(this).closest(".content").find(".vita__text").slideDown();
        var scrollto = $(this).closest(".content__inner");
        $('html, body').animate({ scrollTop: $(scrollto).offset().top - 60 }, 500);
        return false;

    });

    $(".vita__close").click(function () {
        $(this).closest(".content").find(".vita__intro").slideDown();
        $(this).closest(".vita__text").slideUp();
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * stop scroll in background
    // *
    // *

    var disableScroll = false;
    var scrollPos = 0;
    function stopScroll() {
        disableScroll = true;
        scrollPos = $(window).scrollTop();
    }
    function enableScroll() {
        disableScroll = false;
    }
    $(function () {
        $(window).bind('scroll', function () {
            if (disableScroll) $(window).scrollTop(scrollPos);
        });
        $(window).bind('touchmove', function () {
            $(window).trigger('scroll');
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Mobile Menu
    // *
    // *
    $(".hamburger").click(function () {
        if ($('.hamburger').hasClass('is-active')) {
            enableScroll();
        } else {
            stopScroll();
        }
        $(this).toggleClass('is-active');
        $(".nav").slideToggle();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Hide Logo on Scroll
    // *
    // *


    if (screen.width < 768) {
        $(window).scroll(function (event) {
            if( $(this).scrollTop() > 50 ) {
                $('.logo').fadeOut();
            }
            else {
                $('.logo').fadeIn();
            }
        });
    };


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sticky signet and invert signet
    // *
    // *

    $(window).on("load resize scroll", function () {
        //invert nav on black area
        var isOnBlackElement = false;
        $(".dark").each(function () {
            var logoPos = 100;
            var darkStart = $(this).offset().top - $(window).scrollTop();
            var darkEnd = $(this).offset().top + $(this).outerHeight() - $(window).scrollTop();

            if (logoPos > darkStart && logoPos < darkEnd) {
                $(".nav").addClass("nav--invert");
                isOnBlackElement = true;
            }
            else if (!isOnBlackElement) {
                $(".nav").removeClass("nav--invert");
            }
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hash scrollto
    // *
    // *

    $(window).on('load', function () {
        var myhash = window.location.hash;
        if (myhash.length != "") {
            var name = "#my" + myhash.slice(1);
            $("body,html").animate({ scrollTop: $(name).offset().top }, 1200);
        }
    });
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * smoth scroll
    // *
    // *
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top
        }, 1200, 'swing', function () {
            window.location.hash = target;
        });
    });

});
